module.exports = __webpack_public_path__ + "static/media/inovativa.3e3aa9e8.png";